import { useRef } from 'react';
import { isEmpty as _isEmpty } from 'lodash';
import { Transition } from '@headlessui/react';

import { useSwiper } from 'swiper/react';
import NoSSR from '@molecules/NoSSR';

const SlideVideo = ({
  src,
  poster,
  onPlay,
  setOnPlay,
  setCurrentVideoRef,
  bgBlackYN = 'N',
}) => {
  const videoRef = useRef();
  const swiper = useSwiper();

  const onClick = () => {
    swiper.autoplay.stop();

    videoRef.current.play();
    videoRef.current.addEventListener('ended', () => {
      setOnPlay(false);
      swiper.autoplay.start();
      swiper.slideNext();
    });
    setOnPlay(true);
    setCurrentVideoRef(videoRef);
  };

  const onPause = () => {
    // setOnPlay(false);
    swiper.autoplay.start();
  };

  const onStart = () => {
    setOnPlay(true);
    swiper.autoplay.stop();
  };

  return (
    <div className="relative h-full">
      <NoSSR>
        {bgBlackYN == 'Y' && (
          <div className="absolute w-full h-full bg-black" />
        )}
        <video
          controls
          className="absolute w-full h-full disabledFullscreen"
          ref={videoRef}
          // muted
          src={src}
          onPause={onPause}
          onPlay={onStart}
          playsInline
        />
        <Transition
          show={!onPlay}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <img
            className="absolute object-cover w-full h-full"
            src={poster}
            alt=""
            style={{ transform: 'translate3d(0,0,0)' }}
          />
          {bgBlackYN == 'Y' && (
            <div className="absolute w-full h-full bg-black bg-opacity-30"></div>
          )}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20 max-w-[80px] xl:max-w-[150px]">
            <button onClick={onClick}>
              <img
                src="/img/btn-play-big.svg"
                style={{ transform: 'translate3d(0,0,0)' }}
                alt=""
              />
            </button>
          </div>
        </Transition>
      </NoSSR>
    </div>
  );
};

export default SlideVideo;
